module.exports = __webpack_public_path__ + "static/media/gitLab.16e95eac.png";